import React from "react";
import { usePressWithoutScroll } from "../usePressWithoutScroll";

/** The note text is the control. A scroll that ends on it does not toggle. */
export default function NoteToggle({ open, onToggle, children }) {
  const press = usePressWithoutScroll(onToggle);

  return (
    <div
      className="v2-note-toggle"
      role="button"
      tabIndex={0}
      aria-expanded={open}
      onPointerDown={press.onPointerDown}
      onClick={press.onClick}
      onKeyDown={(event) => {
        if (event.key !== "Enter" && event.key !== " ") return;
        event.preventDefault();
        onToggle();
      }}
    >
      {children}
    </div>
  );
}
